import {Component, OnInit} from '@angular/core';
import {LoggerService} from "../../shared/logger/logger.service";
import {Subscription} from "rxjs";
import {TermsConditionsService} from "../terms-conditions.service";
import {UserEnquiry} from "../../common/obj.lib";
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

@Component({
  selector: 'terms-conditions',
  standalone: true,
  imports: [
    SafeHtmlPipe
  ],
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.scss'
})
export class TermsConditionsComponent implements OnInit{

  docContent: string = "";
  private docVersion: number = 0;

  constructor(
    private logger: LoggerService,
    private dataService: TermsConditionsService
  ) {
  }


  ngOnInit(): void {
    this.dataService.get("terms")
      .then(response =>  {
        this.logger.debug('ngOnInit: ', response);
        this.docContent = response.html;
        this.docVersion = response.version_number;
      }).catch(err => {
      this.logger.error('ngOnInit: ', err);
    })
  }


}
